import { BpSortOption } from "@models/ui-components/bp-sort-option";
import { API_CRYPTO_TYPE, API_LEVERAGED_TOKEN_TYPE, API_STOCK_TYPE } from "@helpers/constants";

export enum API_SORT_OPTIONS {
	MARKET_CAP = "market_cap",
	CHANGE = "change",
	PRICE = "price",
	VOLATILITY = "monthly_volatility",
	TRADE_VOLUME = "monthly_trade_volume",
	NAME = "name"
}

export enum DEFAULT_SORT_OPTIONS {
	MARKET_CAP = "market_cap",
	DIRECTION = "desc"
}

export const PRICES_MOBILE_SORT_OPTIONS: BpSortOption[] = [
	{
		label: "sort_option_market_cap",
		value: {
			active: API_SORT_OPTIONS.MARKET_CAP,
			direction: "desc"
		},
		labelAscending: "ascending",
		labelDescending: "descending",
		showArrow: true
	},
	{
		label: "sort_option_price_change_percent",
		value: {
			active: API_SORT_OPTIONS.CHANGE,
			direction: "desc"
		},
		labelAscending: "ascending",
		labelDescending: "descending",
		showArrow: true
	},
	{
		label: "sort_option_asset_price",
		value: {
			active: API_SORT_OPTIONS.PRICE,
			direction: "desc"
		},
		labelAscending: "ascending",
		labelDescending: "descending",
		showArrow: true
	},
	{
		label: "sort_option_volatility_30d",
		value: {
			active: API_SORT_OPTIONS.VOLATILITY,
			direction: "desc"
		},
		labelAscending: "ascending",
		labelDescending: "descending",
		showArrow: true
	},
	{
		label: "sort_option_trade_volume_30d",
		value: {
			active: API_SORT_OPTIONS.TRADE_VOLUME,
			direction: "desc"
		},
		labelAscending: "ascending",
		labelDescending: "descending",
		showArrow: true
	},
	{
		label: "sort_option_alphabetically",
		value: {
			active: API_SORT_OPTIONS.NAME,
			direction: "desc"
		},
		labelAscending: "A-Z",
		labelDescending: "Z-A",
		showArrow: false
	}
];

export const NEW_ON_BP_ASSET_LIST = [
	{ label: "currency_filter_view_all", value: "" },
	{ label: "search_crypto", value: API_CRYPTO_TYPE },
	{ label: "currency_filter_leveraged_tokens", value: API_LEVERAGED_TOKEN_TYPE },
	{ label: "currency_filter_stocks", value: API_STOCK_TYPE }
];

export const PRICES_QUERY_PARAMS = ["filter", "sortActive", "sortDir", "search", "symbol"];
